module.exports = "<div class=\"q-alert q-alert-grey\"> Tracking history and package status updates are not available at this time. </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/proofOfDelivery/podPackageDetailsScreen/html/shipmentHistoryMissing.html
// module id = 1383
// module chunks = 1